module.exports = __webpack_public_path__ + "static/Service3-723a89d8bc02bd016286ab5a756e22aa.png";